export var ValidationLevel;
(function (ValidationLevel) {
    ValidationLevel["Error"] = "error";
    ValidationLevel["Warn"] = "warn";
    ValidationLevel["Off"] = "off";
})(ValidationLevel || (ValidationLevel = {}));
//# sourceMappingURL=types.js.map